import { render, staticRenderFns } from "./LayoutMenu.vue?vue&type=template&id=2717e13e&lang=pug&"
import script from "./LayoutMenu.vue?vue&type=script&lang=js&"
export * from "./LayoutMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports